export default __webpack_public_path__ + "static/media/jeebly.ce742f0e.png";